import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { CommonModule } from '@angular/common';

import { environment } from './../../../../environments/environment';

import { AdminCategory } from './../../../models/admin-category.model';
import { Category, ProductCategoryStatusRequest } from '../../../models/category.model';

import { AdminService } from '../../../services/site/admin.service';
import { CategoryService } from '../../../services/site/category.service';
import { TokenService } from './../../../services/auth/token.service';

@Component({
  selector: 'app-admin-categories',
  templateUrl: './admin-categories.component.html',
  styleUrls: ['./admin-categories.component.scss']
})
export class AdminCategoriesComponent implements OnInit {

  //categories$: Observable<Category[]>;
  categories: Category[] = [];
  category: AdminCategory;
  categoryForm: FormGroup;
  showCategories = false;
  submitted = false;
  //imageSource = `/assets/images`;
  imageSource = `${environment.awsUrl}/categories`;
  loading = false;
  error = '';
  
  constructor(
    private readonly adminService: AdminService,
    private readonly categoryService: CategoryService,
    private readonly fb: FormBuilder,
    private readonly tokenService: TokenService,
    private router: Router
  ) { }

  ngOnInit(): void {
    if (!this.canViewAdmin()) {
      this.router.navigate(['/home']);
    } else {
      this.loadCategories();
      this.categoryForm = this.createCategoryForm();
    }
  }

  get f() { return this.categoryForm.controls; }

  createCategoryForm() {
    return this.fb.group({
      name: ['', Validators.required]
    });
  }

  canViewAdmin() {
    return this.tokenService.isAdmin();
  }

  loadCategories() {
    console.log('getCategories');
    this.loading = true;
    this.categoryService.getCategories()
      .subscribe(data => {
         this.categories = data;
         console.log('Categories loaded:', this.categories);
         this.showCategories = true;
         this.loading = false;
         console.log('refreshed data');
       });
  }

  submit() {
    this.submitted = true;

    if (this.categoryForm.invalid) {
      console.log('Invalid category form');
      return;
    }

    console.log('Creating category');
    const category = new AdminCategory({ id: 0, name: this.f.name.value, imagePath: '', activeFlag: true });

    this.categoryService.createCategory(category)
      .subscribe(d => {
        this.categoryForm = this.createCategoryForm();
        this.loadCategories();
      });
  }

  onEditCategory(category: Category): void {
    // Navigate to edit page or open modal
    this.router.navigate([`/admin/categories/${category.id}`]);
  }

  onAddCategory(): void {
    // Navigate to add new category page
    this.router.navigate(['/admin/categories/0']);
  }

  onDeleteCategory(category: Category): void {
    if (confirm(`Are you sure you want to delete the category "${category.name}"?`)) {
      // Simulate delete operation
      this.categories = this.categories.filter(c => c.id !== category.id);
      console.log('Category deleted:', category.name);
    }
  }

  onToggleStatus(category: Category): void {
    category.activeFlag = !category.activeFlag;
    console.log(`Category "${category.name}" status changed to:`, category.activeFlag ? 'Active' : 'Inactive');
    
    const request: ProductCategoryStatusRequest = {
      productCategoryId: category.id,
      activeFlag: category.activeFlag
    };

    this.adminService.setProductCategoryStatus(request)
      .subscribe({
        next: (data) => {
          console.log('Successfully update category status: ', request);
        },
        error: (err) => {
          console.error('Could not update category status: ', err);
        }
      });
  }

}
